import { render } from "./NuestrosServicios.vue?vue&type=template&id=655d75de&scoped=true&class=banner"
import script from "./NuestrosServicios.vue?vue&type=script&lang=js"
export * from "./NuestrosServicios.vue?vue&type=script&lang=js"

import "./NuestrosServicios.vue?vue&type=style&index=0&id=655d75de&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-655d75de"]])

export default __exports__